export default "__VITE_ASSET__3fc2833d__"